import type { IconProps } from './schemas';

export function CheckMarkIcon({
  className = 'h-4 w-4 self-center inline-block',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 18 18"
    >
      <path
        d="M2.75 9.25L6.75 14.25L15.25 3.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
